import * as React from "react";
function SvgGridRow(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 3.875C2 2.841 2.841 2 3.875 2h16.25C21.16 2 22 2.84 22 3.875v1.25C22 6.159 21.16 7 20.125 7H3.875A1.877 1.877 0 012 5.125v-1.25zm18.75 0a.625.625 0 00-.625-.625H3.875a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625h16.25c.346 0 .625-.28.625-.625v-1.25zM2 11.375c0-1.033.84-1.874 1.875-1.874h16.25c1.034 0 1.875.84 1.875 1.875v1.25c0 1.034-.84 1.875-1.875 1.875H3.875A1.877 1.877 0 012 12.626v-1.25zm18.75 0a.625.625 0 00-.625-.624H3.875a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625h16.25c.345 0 .625-.28.625-.625v-1.25zM3.875 17C2.841 17 2 17.84 2 18.875v1.25C2 21.159 2.84 22 3.875 22h16.25C21.159 22 22 21.16 22 20.125v-1.25C22 17.841 21.16 17 20.125 17H3.875zm16.25 1.25c.345 0 .625.28.625.625v1.25c0 .345-.28.625-.625.625H3.875a.625.625 0 01-.625-.625v-1.25c0-.345.28-.625.625-.625h16.25z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgGridRow);
export default ForwardRef;
